import React from "react"

import { TableCell, TableRow } from "@/components/ui/table"

import LiveDigesterMetricRow from "./LiveDigesterMetricRow"

import type {
  DigesterConfig,
  DigesterPod,
  LiveDigesterMetric,
  MetricColorRange,
} from "../types/feedstockTypes"

export default function LiveDigesterMetrics({
  groups,
  metrics,
  colorRanges,
}: {
  groups: DigesterPod[]
  metrics: LiveDigesterMetric[]
  colorRanges: MetricColorRange[][]
}) {
  let colCount = 0
  groups.forEach((g) => g.digesters.forEach(() => colCount++))
  const digesters: DigesterConfig[] = []
  groups.forEach((g) => g.digesters.forEach((d) => digesters.push(d)))
  return (
    <React.Fragment>
      <TableRow>
        <TableCell colSpan={colCount + 2} className="font-semibold text-lg px-4">
          Live Metrics
        </TableCell>
      </TableRow>
      {metrics.map((m, i) => (
        <LiveDigesterMetricRow
          key={i}
          row={i}
          metric={m}
          colorRanges={colorRanges[i]}
          digesters={digesters}
        />
      ))}
    </React.Fragment>
  )
}
